
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/ui/BackToTop";
import { ShieldCheck, Users, Lock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const GDPRCompliance = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-nation-blue mb-4">GDPR Compliance</h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <div className="grid gap-8">
            <Card className="border-l-4 border-l-nation-blue shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <ShieldCheck className="w-6 h-6 text-nation-blue flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">1. Data Protection Rights</h2>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      Under GDPR, users within the European Union have certain data protection rights, including:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>The right to access your personal data</li>
                      <li>The right to rectification of your personal data</li>
                      <li>The right to erasure of your personal data</li>
                      <li>The right to restrict processing of your personal data</li>
                      <li>The right to data portability</li>
                      <li>The right to object to processing of your personal data</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-blue shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <Lock className="w-6 h-6 text-nation-blue flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">2. Data Processing</h2>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      We process personal data in accordance with GDPR principles, ensuring data is:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>Processed lawfully, fairly, and transparently</li>
                      <li>Collected for specified, explicit, and legitimate purposes</li>
                      <li>Adequate, relevant, and limited to what is necessary</li>
                      <li>Accurate and kept up to date</li>
                      <li>Stored only as long as necessary</li>
                      <li>Processed securely</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default GDPRCompliance;
